export enum TrialBalanceColumnTitles {
Text,
Period,
TextAndPeriod,
}
